// Probabilidad de ganar de una raspadita según el valor `probability` del CMS.
// Espejo de scratch_probability.dart (app nativa) y del CMS: mantenerlos sincronizados.
//
// Antes el valor era N y se ganaba "1 de cada N". El 1 (Muy alta 75%) es nuevo:
// las versiones viejas de la app lo leen como 1 de cada 1 (siempre ganan).
const WIN_PERCENT_MAP: { [key: number]: number } = {
    0: 100,  // Siempre gana
    1: 75,   // Muy alta
    2: 50,   // Alta
    4: 25,   // Media
    6: 100 / 6, // Media anterior (ya no se ofrece en el CMS)
    8: 12.5, // Baja
};

/** % (0..100) de que el usuario gane. Valores fuera de la tabla usan la regla vieja 1/N. */
export function scratchWinPercent(probability: number): number {
    if (probability == null || probability <= 0) return 100;
    return WIN_PERCENT_MAP[probability] ?? 100 / probability;
}

/** Sortea si el usuario gana según la probabilidad de la raspadita. */
export function isScratchWinner(probability: number): boolean {
    return Math.random() * 100 < scratchWinPercent(probability);
}
